import { ReactNode } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import RafflePopup from "./RafflePopup";

const Layout = ({ children }: { children: ReactNode }) => (
  <div className="min-h-screen flex flex-col">
    <Navbar />
    <main className="flex-1">{children}</main>
    <Footer />
    <RafflePopup />
  </div>
);

export default Layout;
